import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { CRUDFunction } from "../../../reduxCURD/container";
import MyPlanningTable from "../../Dashboard/MyPlanningTable";
import { languageService } from "../../../Language/language.service";
import { deriveCRUDNames } from "../crudHelpers";
import { themeService } from "../../../theme/service/activeTheme.service";
import { DashboardPageStyle } from "../../Dashboard/styles/DashboardPageStyle";
import SpinnerLoader from "../../Common/SpinnerLoader";
import { commonStylesDashboard } from "../../Dashboard/styles/commonStylesDashboard";
import { CommonWidgetMethods } from "./Common";
import { dateSortArrayByField } from "../../../utils/sortingMethods";

import PropagateLoader from "react-spinners/PropagateLoader";
class InspectionListWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinnerLoading: false,
      inspectionsDataToShow: [],
      listPage: 0,
      planPageSize: 30,
      planFilter: "all",
    };
    this.getCombinedData = this.getCombinedData.bind(this);
    this.fetchCall = this.fetchCall.bind(this);
  }
  fetchCall(settings, dateRange, filterLocations) {
    let sett = settings.map((s) => {
      return { ...s, lineIds: filterLocations };
    });
    // const url = `summary?settings=${JSON.stringify(sett)}&dateRange=${JSON.stringify(dateRange)}`;

    // this.props.getInspectionsLists(url);
    this.props.createInspectionsList(
      {
        settings: sett,
        dateRange: dateRange,
      },
      "WidgetSettings",
      "/summary",
    );
  }
  componentDidMount() {
    const { settings } = this.props.settings;
    const { dateRange, filterLocations } = this.props;

    this.fetchCall(settings, dateRange, filterLocations);
  }

  componentDidUpdate(prevProps) {
    const { settings } = this.props.settings;
    const { dateRange, actionType, filterLocations, inspectionsLists } = this.props;

    if (actionType === "INSPECTIONSLIST_CREATE_REQUEST" && actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: true });
    }

    const dateChanged = dateRange.month !== prevProps.dateRange.month || dateRange.year !== prevProps.dateRange.year;

    if (dateChanged || filterLocations !== prevProps.filterLocations) {
      this.fetchCall(settings, dateRange, filterLocations);
    }

    if (actionType === "INSPECTIONSLIST_CREATE_SUCCESS" && actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: false, inspectionsDataToShow: inspectionsLists });
    }

    if (actionType === "INSPECTIONSLIST_CREATE_FAILURE" && actionType !== prevProps.actionType) {
      console.error("Failed to fetch inspections data.");
      this.setState({ spinnerLoading: false });
    }
  }

  handlePageStateSave = (page) => {
    this.setState({ listPage: page });
  };

  resetPage = () => {
    this.setState({ listPage: 0 });
  };

  getCombinedData() {
    const { inspectionsDataToShow } = this.state;
    let inspectionList = inspectionsDataToShow ? inspectionsDataToShow.inspectionList : {};
    let list = [];

    if (inspectionList && inspectionList.lines) {
      Object.entries(inspectionList.lines).forEach(([id, val]) => {
        list.push(...val.list);
      });
    }

    return list;
  }
  render() {
    const { inspectionsDataToShow, listPage, planPageSize, planFilter, spinnerLoading } = this.state;

    let filteredData = this.getCombinedData();
    let sorted = dateSortArrayByField(filteredData, "date", false);

    if (spinnerLoading || !inspectionsDataToShow) {
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 150 }}>
          <PropagateLoader
            color={themeService({ default: "rgb(55, 139, 119)", retro: "var(--first)", electric: "rgba(64, 118, 179,.5)" })}
            sizeUnit={"px"}
            size={10}
          />
        </div>
      );
    }

    return (
      <div md="12" style={{ padding: "20px", margin: 0, backgroundColor: "white" }}>
        <Row style={themeService(DashboardPageStyle.headingRow)}>{languageService("Inspections")}</Row>
        <Row style={themeService(DashboardPageStyle.tablesContainerRow)}>
          <Col style={{ ...themeService(commonStylesDashboard.innerContainerCol), padding: 0, margin: 0 }}>
            <MyPlanningTable
              journeyPlans={sorted}
              actionType={this.props.actionType}
              handlePageSave={this.handlePageStateSave}
              pageSize={planPageSize}
              page={listPage}
              planFilter={planFilter}
              resetPage={this.resetPage}
              dashBoardV2={true}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const actionOptions = {
  create: true,
  update: false,
  read: true,
  delete: false,
};

const InspectionListWidgetContainer = CRUDFunction(InspectionListWidget, "inspectionsList", actionOptions, null, [], "dashboard");

export default InspectionListWidgetContainer;



// WEBPACK FOOTER //
// ./src/components/NewDashboard/widgets/InspectionListWidget.jsx